import React, { Component } from 'react';

export const AccordionPanel = (props) => props;

export class Accordion extends Component {
  constructor(props) {
    super(props);
    const { index = -1 } = props;
    this.state = {
      index,
    };
  }
  handleClick(e, index) {
    this.setState((prevState, props) => ({
      ...prevState,
      index: index === prevState.index ? -1 : index,
    }));
  }
  render() {
    const accordions = React.Children.toArray(this.props.children);
    const isActive = (index) => this.state.index === index;
    const headers = accordions.map((accordion, index) => (
      <button 
        key={`accordion__header-${index}`} 
        className={`${accordion.props.customClassName ? ' ' + accordion.props.customClassName : ''} border border-input-secondary rounded-radius px-4 py-2 flex items-center justify-between gap-2 font-medium ${isActive(index) ? 'bg-input-secondary text-white' : 'bg-transparent text-input-secondary'}`}
        onClick={(e) => this.handleClick(e, index)}>
        {accordion.props.header || ''}
        {accordion.props.icon ? (
          accordion.props.icon
        ) : (
          <span className='icon icon-outlined'>keyboard_arrow_down</span>
        )}
      </button>
    ));
    const panels = accordions.map((accordion, index) => (
      <div
        className={`accordion__panel ${
          accordion.props.panelWrapperClassName
            ? accordion.props.panelWrapperClassName
            : ''
        } ${isActive(index) ? 'block' : 'hidden'}`}
        key={`accordion__panel-${index}`}
      >
        {accordion.props.children}
      </div>
    ));
    return (
      <div className={this.props.className}>
        <nav className={`accordion__header-container grid grid-cols-2 gap-4`}>{headers}</nav>
        {panels}
      </div>
    );
  }
}
